<script lang="ts">
  import AnimatedSection from '$components/AnimatedSection.svelte';
  import { m } from '$lib/paraglide/messages.js';
  import { localizeHref } from '$lib/paraglide/runtime.js';

  interface Props {
    headline?: string;
    description?: string;
    buttonText?: string;
    buttonHref?: string;
  }

  let {
    headline = m.cta_default_headline(),
    description = m.cta_default_description(),
    buttonText = m.cta_default_button(),
    buttonHref = localizeHref('/contact')
  }: Props = $props();
</script>

<section class="bg-mocha py-[10vh] md:py-[12vh] px-[4vw]">
  <div class="max-w-[1000px] mx-auto text-center px-2">
    <AnimatedSection direction="up" stagger={0.15}>
      <h2 class="font-display text-[clamp(1.5rem,4.5vw,3.5rem)] leading-[1.15] tracking-[-0.01em] text-parchment">{headline}</h2>
      <p class="font-body text-[1rem] md:text-[1.05rem] leading-[1.6] text-parchment/80 max-w-[600px] mx-auto mt-[3vh]">{description}</p>
      <a href={buttonHref} class="inline-block mt-[4vh] font-accent uppercase text-[0.7rem] md:text-[0.75rem] tracking-[0.1em] text-charcoal bg-gold-soft rounded-[40px] px-8 md:px-[42px] py-3.5 md:py-4 hover:bg-gold hover:scale-[1.03] transition-all duration-300 cursor-pointer" aria-label={buttonText}>
        {buttonText}
      </a>
    </AnimatedSection>
  </div>
</section>
